import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {ProviderSpecialtyDTO} from '../models/ProviderSpecialtyDTO';
import {environment} from '../../../../environments/environment';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';

@Injectable({
  providedIn: 'root'
})
export class ProviderSpecialityService {
  private url = environment.baseUrl + '/provider-speciality';

  constructor(private httpClient: HttpClient) { }

  getListOfProviderSpecialities(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<ProviderSpecialtyDTO>> {
    return this.httpClient.post<PagedResponseDTO<ProviderSpecialtyDTO>>(this.url + '/filter', pagedRequestDTO);
  }
}
